/**
 * Form helper utilities for consistent handling of form field data
 */

/**
 * Parses field options that may be stored as a JSON string or array.
 * Handles both formats and provides graceful error handling.
 *
 * @param {string|Array} options - The options data, either as a JSON string or array
 * @returns {Array} - Parsed options array, or empty array if invalid
 */
export const parseFieldOptions = (options) => {
	if (typeof options === 'string' && options) {
		try {
			const parsed = JSON.parse(options);
			return Array.isArray(parsed) ? parsed : [];
		} catch (e) {
			console.error('Error parsing field options:', e);
			return [];
		}
	}
	return Array.isArray(options) ? options : [];
};

/**
 * Resolves a stored option value (slug/UUID) to its human-readable label.
 * Options can be {value, label} objects or plain strings.
 *
 * @param {Array} options - Parsed options array from parseFieldOptions()
 * @param {string} storedValue - The stored value to look up
 * @returns {string} - The label if found, otherwise the original storedValue
 */
export const resolveOptionLabel = (options, storedValue) => {
	const match = options.find((opt) => (opt.value || opt) === storedValue);
	return match ? match.label || match : storedValue;
};
